<template>
  <div class="buy-notice">
    <div class="buy-notice__main">
      <transition-group name="slide-fade" tag="div" v-on:after-leave="afterLeave" v-on:after-enter="afterEnter">
        <template v-for="item of data">
          <div v-show="item.show" :key="item.phone" class="buy-notice__item">{{item.phone}} 已报名 {{item.time}}分钟前</div>
        </template>
      </transition-group>
    </div>
  </div>
</template>
<script>
import { getRndInteger } from '@utils/tool';
export default {
  name: 'BuyNotice',
  data() {
    return {
      data: [],
      index: 0,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getData(100);
      this.begin();
    });
  },
  methods: {
    begin() {
      this.$set(this.data[this.index], 'show', true);
    },
    afterEnter(el) {
      setTimeout(() => {
        this.$set(this.data[this.index++], 'show', false);
      }, 2500);
    },
    afterLeave(el) {
      if (this.index >= this.data.length) {
        this.index = 0;
        // this.resetData()
      }
      setTimeout(() => {
        this.$set(this.data[this.index], 'show', true);
      }, 500);

    },
    resetData() {
      this.data.forEach(element => {
        element.time = getRndInteger(1, 10);
      });
    },
    getMoble() {
      const phoneHeadData = [139, 138, 137, 136, 135, 134, 159, 158, 157, 150, 151, 152, 188, 187, 182, 183, 184, 178, 130, 131, 132, 156, 155, 186, 133, 153, 189, 180, 181, 177];
      let i = parseInt(phoneHeadData.length * Math.random());
      let num = phoneHeadData[i] + '****';
      for (let j = 0; j < 4; j++) {
        num = num + Math.floor(Math.random() * 10);
      }
      return num;
    },
    getData(num) {
      const data = [];
      while (num > 0) {
        let pn = this.getMoble();
        if (!data.find(item => item.phone === pn)) {
          num--;
          data.push({ phone: this.getMoble(), time: getRndInteger(1, 10), show: false },);
        }
      }
      this.data = data;
    }
  }
};
</script>
<style lang="stylus" scoped>
.buy-notice{
  position: fixed;
  left: 20px;
  top: 140px;
  .buy-notice__main{
    position: relative;
  }
  .buy-notice__item{
    position: absolute;
    left: 0;
    top: 0;
    width: 200px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    font-size: 12px;
    color: #fff;
    background:rgba(0,0,0,0.45);
    border-radius: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
  }
}

.slide-fade-enter-active {
  transition: all .8s ease;
}
.slide-fade-leave-active {
  opacity: 1;
  transition: all .8s cubic-bezier(1.0, 0.8, 0.8, 1.0);
}
.slide-fade-leave-to{
  transform: translateY(-20px);;
  opacity: 0;
}
.slide-fade-enter {
  opacity: 0;
  transform: translateY(10px);
}

.fade-enter-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.fade-leave-active {
  opacity: 1;
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.fade-leave-to, .fade-enter{
  opacity: 0;
}

</style>